export default __webpack_public_path__ + "static/media/Level=5.be70c42f.svg";